<template>
  <v-chip-group v-model="valueInput" color="primary" column mandatory>
    <v-chip
      filter
      v-for="(value, key) in _vehicleCheckListStatusAllObj"
      :value="key"
      :color="vehicleCheckListStatusCardColor(key)"
      outlined
      :key="key"
    >
      <span class="px-1">{{ value }}</span>
    </v-chip>
  </v-chip-group>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VehicleCheckListFilterStatus",
  mounted() {
    this.getParamQuery();
  },
  props: {
    value: {},
  },
  data: () => ({
    queryOrder: {
      status: "status",
    },
    settingValue: "all",
  }),
  methods: {
    getParamQuery() {
      Object.keys(this.queryOrder).forEach((key) => {
        if (!_.isNil(this.$route.query[key])) {
          switch (key) {
            case "status":
              this.settingValue = this.$route.query[key];
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      vehicleCheckListStatusCardColor:
        "vehicle_checklist/vehicleCheckListStatusCardColor",
    }),
    _vehicleCheckListStatusAllObj: function () {
      return this.$store.state.vehicle_checklist.vehicleCheckListStatusAllText;
    },
    valueInput: {
      get() {
        return this.settingValue;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
